<div class="payouts-container">
  <div class="page-header">
    <h1>Sub-Contractor Payouts</h1>
    <p class="subtitle">Onboard sub-contractors to Stripe and pay them for completed work</p>
  </div>

  <div class="error-banner" *ngIf="error">{{ error }}</div>
  <p *ngIf="loading">Loading…</p>

  <div class="payout-card" *ngFor="let r of rows">
    <div class="payout-head">
      <div>
        <div class="payout-name">{{ r.contractor.name }}</div>
        <div class="payout-email">{{ r.contractor.email }}</div>
      </div>
      <div class="payout-status">
        <span *ngIf="r.loadingStatus" class="chip muted">checking…</span>
        <span *ngIf="!r.loadingStatus && r.status?.payoutsEnabled" class="chip ok">Payouts enabled</span>
        <span *ngIf="!r.loadingStatus && r.status?.onboarded && !r.status?.payoutsEnabled" class="chip warn">Setup incomplete</span>
        <span *ngIf="!r.loadingStatus && !r.status?.onboarded" class="chip">Not set up</span>
      </div>
    </div>

    <div class="payout-actions">
      <button class="btn btn-secondary" *ngIf="!r.status?.payoutsEnabled" (click)="startOnboarding(r)">
        {{ r.status?.onboarded ? 'Finish payout setup' : 'Set up payouts' }}
      </button>
      <button class="btn btn-secondary" *ngIf="r.status?.onboarded" (click)="openDashboard(r)">Stripe dashboard</button>
      <button class="btn btn-secondary" (click)="refreshStatus(r)">Refresh</button>
    </div>

    <div class="payout-pay" *ngIf="r.status?.payoutsEnabled">
      <input type="number" placeholder="Amount (USD)" min="0" step="0.01"
             [(ngModel)]="r.payAmount" name="amt{{ r.contractor.id }}">
      <input type="text" placeholder="What for" [(ngModel)]="r.payDescription" name="desc{{ r.contractor.id }}">
      <button class="btn btn-primary" (click)="pay(r)" [disabled]="r.paying">
        {{ r.paying ? 'Sending…' : 'Pay' }}
      </button>
    </div>

    <p class="row-error" *ngIf="r.error">{{ r.error }}</p>
    <p class="row-ok" *ngIf="r.message">{{ r.message }}</p>

    <table class="payments-table" *ngIf="r.payments.length">
      <tr><th>Date</th><th>Amount</th><th>Status</th><th>Description</th></tr>
      <tr *ngFor="let p of r.payments">
        <td>{{ p.createdAt | date:'short' }}</td>
        <td>{{ p.amount | currency:(p.currency || 'usd').toUpperCase() }}</td>
        <td>{{ p.status }}</td>
        <td>{{ p.description }}</td>
      </tr>
    </table>
  </div>
</div>
